export const enum ApiResponseStatus {
  BadRequest = 400,
  Unauthorized = 401,
}
